import React from "react"
import {
  Flex, Heading, Text, Box,
} from "@chakra-ui/react"
import StatRow from "components/StatRow"
import Link from "components/elements/Link"
import { asNumber } from "utilities/strings"
import { TextMessageDeliveryCounts, TextMessageFallbackCounts } from "sharedTypes"
import { TEXT_MESSAGING_TRACKING_ARTICLE_LINK } from "utilities/externalLinks"

type Props = {
  deliveryCounts: TextMessageDeliveryCounts
  fallbackCounts?: TextMessageFallbackCounts
  channel: "sms" | "whatsapp"
}

const TextMessageEngagements = ({
  deliveryCounts: {
    sent,
    delivered,
    deliveryUnknown,
    undelivered,
    failed,
    awaitingOptIn,
    optInDeclined,
    optInExpired,
  },
  fallbackCounts,
  channel,
}: Props) => {
  const isWhatsApp = channel === "whatsapp"
  const optInBuckets = isWhatsApp ? (awaitingOptIn + optInDeclined + optInExpired) : 0
  const allRecipients = sent + delivered + deliveryUnknown + undelivered + failed + optInBuckets
  const fallbackDelivered = fallbackCounts?.delivered || 0

  return (
    <Box>
      <Box borderBottomWidth={1} pb={4} mb={3}>
        <Text fontSize="2xl">{isWhatsApp ? "WhatsApp" : "SMS"} Delivery</Text>
      </Box>
      <Box ml={5}>
        <Flex justify="space-between" mb={6}>
          <Heading fontSize="lg" fontWeight="normal">All Recipients</Heading>
          <Text fontSize="lg">{asNumber(allRecipients)}</Text>
        </Flex>
        <Flex flexDirection="column" gap={0.5}>
          <StatRow label="Sent" count={sent} total={allRecipients} color="textStatus.sent" />
          <StatRow label="Delivered" count={delivered} total={allRecipients} color="textStatus.delivered" />
          {fallbackDelivered > 0 && (
            <Box pl={6}>
              <StatRow label="via WhatsApp" count={delivered - fallbackDelivered} total={allRecipients} color="textStatus.delivered" />
              <StatRow label="via SMS fallback" count={fallbackDelivered} total={allRecipients} color="textStatus.delivered" />
            </Box>
          )}
          <StatRow label="Delivery Unknown" count={deliveryUnknown} total={allRecipients} color="textStatus.deliveryUnknown" />
          <StatRow label="Undelivered" count={undelivered} total={allRecipients} color="textStatus.undelivered" />
          <StatRow label="Failed" count={failed} total={allRecipients} color="textStatus.failed" />
          {isWhatsApp && (
            <>
              <StatRow label="Awaiting Opt-In" count={awaitingOptIn} total={allRecipients} color="yellow.400" />
              <StatRow label="Opt-In Declined" count={optInDeclined} total={allRecipients} color="textStatus.undelivered" />
              <StatRow label="Opt-In Expired" count={optInExpired} total={allRecipients} color="textStatus.deliveryUnknown" />
            </>
          )}
        </Flex>
        <Text mt={8}>
          <>To learn more, see: </>
          <Link target="_blank" href={TEXT_MESSAGING_TRACKING_ARTICLE_LINK}>Text Message Tracking</Link>
        </Text>
      </Box>
    </Box>
  )
}

export default TextMessageEngagements
